import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { bonuses } from '../data/content';
export function BonusesSection() {
  const total = bonuses.reduce((sum, b) => sum + b.value, 0);
  return <section className="w-full bg-ink py-16 sm:py-24" aria-label="Bonuses" data-id="element-68" data-mp="qu30imt7hijr">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-69" data-mp="qw5wrokyc7wx">
        <SectionHeading title={<>
              Get <span className="text-volt" data-id="element-71" data-mp="zv13r2vtlm1a">5 additional</span> diagnostic tools included
            </>} sub="Practical resources designed to make your workflow easier." data-id="element-70" data-mp="14s9nh7wm9y4n" />

        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:gap-6" data-id="element-72" data-mp="19kkpcgax3tzu">
          {bonuses.map((b, i) => <article key={b.title} className={`flex flex-col overflow-hidden rounded-none border-y border-line bg-[#080f1d] -mx-4 sm:mx-0 sm:rounded-2xl sm:border ${i === bonuses.length - 1 ? 'md:col-span-2 md:mx-auto md:max-w-[calc(50%-12px)]' : ''}`} data-id="element-73" data-mp="1njkavf34vsrs" data-mpi={i}>
              <img src={b.image} alt={`Bonus ${i + 1}: ${b.title}`} className="w-full" loading="lazy" data-id="element-74" data-mp="3tsou7msbo6rk" />
              <div className="flex flex-1 flex-col px-5 pb-6 pt-1 sm:px-6" data-id="element-75" data-mp="2kulgofq23a2">
                <div className="flex items-center justify-between gap-3" data-id="element-76" data-mp="7kz0sb4w8ryp">
                  <span className="inline-flex items-center gap-1.5 rounded-md bg-alert px-2.5 py-1 font-display text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-77" data-mp="ck1vp2r5thsy">
                    <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="gjan40yq93lc" />
                    Bonus {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="text-sm font-semibold text-mist" data-id="element-79" data-mp="qa5c3d3cyhah">
                    Value <span className="line-through" data-id="element-80" data-mp="vajmh1sfm3bo">${b.value}</span>{' '}
                    <span className="font-extrabold text-ok" data-id="element-81" data-mp="v8gljmpqqps6">FREE</span>
                  </span>
                </div>
                <h3 className="mt-3 font-display text-[26px] font-extrabold uppercase leading-[1] text-white sm:text-3xl" data-id="element-82" data-mp="al8pr689gbi0">
                  {b.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-mist" data-id="element-83" data-mp="5k1fn0inb086">{b.body}</p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border-2 border-dashed border-volt px-5 py-5 text-center" data-id="element-84" data-mp="fk204ps93mdy">
          <p className="font-display text-2xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-85" data-mp="taf8gt92133t">
            Total bonus value: <span className="text-volt line-through decoration-alert decoration-[3px]" data-id="element-86" data-mp="ocds4g30jhw1">${total}</span>
          </p>
          <p className="mt-1 text-base font-semibold text-ok" data-id="element-87" data-mp="137tmynbf3hth">All five bonuses are included with your purchase.</p>
        </div>

        <SectionCta label="Claim my 5 free bonuses" data-id="element-88" data-mp="350zsob1bhfpm" />
      </div>
    </section>;
}